module.exports = __webpack_public_path__ + "img/branch-particle-18.0d183f22.png";